'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayName = undefined;

var _fileMetadataGetters = require('./fileMetadataGetters');

var displayName = exports.displayName = function displayName(fileMetadata) {
  var name = (0, _fileMetadataGetters.getName)(fileMetadata);
  var extension = (0, _fileMetadataGetters.getExtension)(fileMetadata);

  if (!extension) {
    return name;
  }

  return name + '.' + extension;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/file-metadata/operators/displayName.js
// module id = 1121
// module chunks = 2 3